import classNames from 'classnames';
import Tooltip from 'rc-tooltip';
import * as React from 'react';
import { Fragment } from 'react';
import { ReactComponent as IconCheckmark } from '../../../assets/icons/checkmark.svg';
import { ReactComponent as InfoIcon } from '../../../assets/icons/info.svg';
import '../../../styles/BoxInput.scss';

interface IProps {
  id: any;
  type: IBoxInputTypes;
  alignment: IBoxInputAlignment;
  style?: IBoxInputStyles;
  options: any;
  moreIndustriesVisible?: any;
  onChange: any;
  selected: any;
  selectAll?: any;
  deselectAll?: any;
  isShowIcons?: boolean;
  size?: IBoxCardSizes;
}

interface IState {
  selected: any;
}

export enum IBoxInputTypes {
  Radio = 'Radio',
  Checkbox = 'Checkbox',
}

export enum IBoxInputAlignment {
  Vertical = 'Vertical',
  Horizontal = 'Horizontal',
  FullWidth = 'FullWidth',
  TwoColumns = 'TwoColumns',
}

export enum IBoxInputStyles {
  Card = 'Card',
}

export enum IBoxCardSizes {
  SmallCard = 'SmallCard',
  NormalCard = 'NormalCard',
}

export class BoxInput extends React.Component<IProps, IState> {
  constructor(props?: any, context?: any) {
    super(props, context);
    this.state = {
      selected: [],
    };
  }

  handleOnChange = (e, keypress?, idx?) => {
    const value = e.target.value;
    const checked = e.target.checked;
    let { type, selected } = this.props;

    selected = selected ? selected : [];

    if (type === IBoxInputTypes.Checkbox) {
      if (keypress) {
        if (checked) {
          selected.splice(selected.indexOf(value), 1);
        } else if (!checked) {
          selected.push(value);
        }
      } else {
        if (checked && !selected.includes(value)) {
          selected.push(value);
        } else if (!checked && selected.includes(value)) {
          selected.splice(selected.indexOf(value), 1);
        }
      }
    } else {
      selected = value;
    }

    if (this.props.options[idx]) {
      if (this.props.options[idx].gtmEvent && !checked) {
        // @ts-ignore
        if (window.dataLayer) {
          // @ts-ignore
          window.dataLayer.push({
            event: this.props.options[idx].gtmEvent,
          });
        }
      }
    }

    this.props.onChange && this.props.onChange(selected);
  };

  checked = (option) => {
    const { type, selected } = this.props;
    if (option.hasChildren) {
      if (selected === option.value) {
        return true;
      }
      for (const child of option.children) {
        if (selected === child.value) {
          return true;
        }
      }
      return false;
    } else {
      return type === IBoxInputTypes.Checkbox ? selected?.includes(option.value) : selected === option.value;
    }
  };

  render() {
    const { options, type, alignment, style, id, isShowIcons, size } = this.props;

    return (
      <div
        className={classNames(
          'box-input-wrapper',
          { radio: type === IBoxInputTypes.Radio },
          { checkbox: type === IBoxInputTypes.Checkbox },
          { vertical: alignment === IBoxInputAlignment.Vertical },
          { horizontal: alignment === IBoxInputAlignment.Horizontal },
          { fullWidth: alignment === IBoxInputAlignment.FullWidth },
          { twoColumns: alignment === IBoxInputAlignment.TwoColumns },
          { 'card-style': style === IBoxInputStyles.Card },
        )}
      >
        {!!options &&
          options.map((option, idx) => {
            const checked = this.checked(option);
            const isDisabled: boolean = 'disabled' in option ? option.disabled : false;
            const checkMark = (
              <i className='box-input-checkmark'>{type === IBoxInputTypes.Checkbox && <IconCheckmark />}</i>
            );

            return (
              <Fragment key={`box-input-key-${id}-${idx}`}>
                <label
                  htmlFor={`box-input-option-${idx}-${id}`}
                  className={classNames('box-input-label', option?.customClass, {
                    checked: checked,
                    disabled: isDisabled,
                    'small-size': size === IBoxCardSizes.SmallCard,
                    'normal-size': size === IBoxCardSizes.NormalCard,
                  })}
                >
                  {alignment == IBoxInputAlignment.FullWidth
                    ? checkMark
                    : isShowIcons && <div className='circle-icon'></div>}

                  <div className='box-input-text-wrapper'>
                    <div className='box-input-title'>
                      {option.title}

                      <Tooltip
                        overlayClassName={'rc-tooltip-bg-white'}
                        placement={'top'}
                        overlay={option.text ? <b>{option.text}</b> : ''}
                      >
                        <InfoIcon className='ms-3 info-icon' />
                      </Tooltip>
                    </div>
                  </div>
                  {isDisabled && option.labelChildren}
                  <input
                    disabled={isDisabled}
                    type='checkbox'
                    value={option.value}
                    className='box-input-input'
                    id={`box-input-option-${idx}-${id}`}
                    checked={checked}
                    onChange={(e) => this.handleOnChange(e, false, idx)}
                    onKeyPress={(e) => {
                      var code = e.keyCode || e.which;
                      if (code === 13) {
                        this.handleOnChange(e, true, idx);
                      }
                    }}
                  />

                  {alignment == IBoxInputAlignment.FullWidth
                    ? isShowIcons && <div className='circle-icon'></div>
                    : checkMark}
                </label>

                {option.hasChildren && this.props.moreIndustriesVisible}
              </Fragment>
            );
          })}
      </div>
    );
  }
}
